import { useLocation } from "@tanstack/react-router";

export const useDeviceType = () => {
	const { pathname } = useLocation();
	const isEvaluatedDevice = pathname.includes("/peer");
	const isScannerDevice = !isEvaluatedDevice;
	const device = isEvaluatedDevice ? "evaluated-device" : "scanner-device";

	return { device, isEvaluatedDevice, isScannerDevice };
};
